import EventBus from '@mvps-genesis/event-bus';
import AjaxAddToCart from '@mvps-genesis/ajax-add-to-cart';
import {Message} from '@mvps-genesis/messages';

export default class AjaxAddToCartExtended extends AjaxAddToCart {

	constructor () {
		super(...arguments);
	}

	onSubmit (e) {

		if (this.actionInputElement.value !== 'ADPR') {
			return;
		}

		e.preventDefault();
		e.stopImmediatePropagation();

		// Set form action / input action
		this.formElement.action = this.submitButtonElement.dataset.action;
		this.actionInputElement.value = 'ADPR';

		const formData = new FormData(this.formElement);
		const request = new XMLHttpRequest();

		// Set idle status
		this.formElement.dataset.status = 'idle';

		if (this.formElement.dataset.status !== 'processing') {

			// Set status while processing
			this.formElement.dataset.status = 'processing';

			// Disable button while processing
			this.submitButtonElement.disabled = true;

			// Set text of button to processing
			this.submitButtonElement[this.submitButtonTextProperty] = this.processingButtonText;

			// Clear response message
			this.messageContainer.clear();

			// Handle readystatechange callback
			request.onreadystatechange = () => {

				// Only run if the request is complete
				if (request.readyState !== 4) {
					return;
				}

				// Defining product data for Google Tag Manager AddToCart event
				let productData = {
					brand: this.formElement.getAttribute('data-gtm-brand') ? this.formElement.getAttribute('data-gtm-brand') : '',
					category: this.formElement.getAttribute('data-gtm-category') ? this.formElement.getAttribute('data-gtm-category') : '',
					code: this.formElement.getAttribute('data-gtm-code') ? this.formElement.getAttribute('data-gtm-code') : '',
					name: this.formElement.getAttribute('data-gtm-name') ? this.formElement.getAttribute('data-gtm-name') : '',
					price: this.formElement.getAttribute('data-gtm-price') ? this.formElement.getAttribute('data-gtm-price') : '',
					product_id: this.formElement.getAttribute('data-gtm-productid') ? this.formElement.getAttribute('data-gtm-productid') : '',
					product_image: this.formElement.getAttribute('data-gtm-image') ? this.formElement.getAttribute('data-gtm-image') : ''
				};

				// Define event payload structure
				let payload = {
					data: request.response,
					formData: formData,
					// To be updated later in the switch statement ↓
					message: null,
					productData: productData,
					request: request,
					success: false
				};

				// Process our return data
				if (request.status === 200) {

					// What do when the request is successful
					const pageCodeResponseHeader = request.getResponseHeader('x-mm-page-code');

					// Reset button text
					this.submitButtonElement.disabled = false;
					this.submitButtonElement[this.submitButtonTextProperty] = this.submitButtonText;

					switch (pageCodeResponseHeader) {

					case 'BASK': {

						this.onSuccess();

						payload.success = true;

						break;
					}
					case 'PATR': this.onMissingAttributes();
						break;
					case 'PROD': this.onMissingAttributes();
						break;
					case 'PLMT': this.onLimitedStock();
						break;
					case 'POUT': this.onOutOfStock();
						break;
					default: this.onOther();
						break;
					}

					// Set payload message
					payload.message = this.messageContainer.currentMessage.message;

				}
				else {

					// What do when the request fails
					let errorMessage = `${ this.constructor.name } - The request failed with a status of: ${ request.status }`;
					console.error(errorMessage);

					payload.message = 'Product Add Failed: Product Unavailable';

					// Reset button text
					this.submitButtonElement.disabled = false;
					this.submitButtonElement[ this.submitButtonTextProperty ] = this.submitButtonText;

				}

				// Dispatch global event
				EventBus.dispatchEvent('MVPS:addToCart', payload);

				// Reset form status
				this.formElement.dataset.status = 'idle';

			};

			/**
			 * Create and send a request
			 * The first argument is the post type (GET, POST, PUT, DELETE, etc.)
			 * The second argument is the endpoint URL
			 */
			request.open(this.formElement.method, this.formElement.action, true);
			request.responseType = 'document';
			request.send(formData);

		}

	}

	onMissingAttributes() {

		const findRequired = this.formElement.getElementsByClassName( '.is-required' );
		const missingAttributes = [];

		for ( let id = 0; id < findRequired.length; id++ ) {
			missingAttributes.push( ' ' + findRequired[id].title );
		}

		this.messageContainer.add( new Message( 'All <em class="u-color-error">Required</em> options have not been selected for:', this.missingAttributesMessage.options));

	}

}
